const AdZones = {
  CHECKOUT_HEADER_BANNER: 'CHECKOUT_HEADER_BANNER',
  CHECKOUT_SUMMARY_BANNER: 'CHECKOUT_SUMMARY_BANNER',
  FOOTER_BANNER: 'FOOTER_BANNER',
  HEADER_CONTENT: 'HEADER_CONTENT',
  INFO_PAGE_BANNER: 'INFO_PAGE_BANNER',
  MAIN_BANNER: 'MAIN_BANNER',
  MEGA_MENU_BANNER: 'MEGA_MENU_BANNER',
  NOT_FOUND_CONTENT: 'NOT_FOUND_CONTENT',
  ORDER_CONFIRMATION_CONTENT: 'ORDER_CONFIRMATION_CONTENT',
  POPUP_CONTENT: 'POPUP_CONTENT',
  PRODUCT_PAGE_BANNER_1: 'PRODUCT_PAGE_BANNER_1',
  PRODUCT_PAGE_BANNER_2: 'PRODUCT_PAGE_BANNER_2',
  PRODUCT_PAGE_BANNER_3: 'PRODUCT_PAGE_BANNER_3',
  PRODUCT_PAGE_BANNER_4: 'PRODUCT_PAGE_BANNER_4',
  PRODUCT_PAGE_CONTENT_1: 'PRODUCT_PAGE_CONTENT_1',
  PRODUCT_PAGE_CONTENT_2: 'PRODUCT_PAGE_CONTENT_2',
  PRODUCT_PAGE_CONTENT_3: 'PRODUCT_PAGE_CONTENT_3',
  PRODUCT_PAGE_CONTENT_4: 'PRODUCT_PAGE_CONTENT_4',
  SIDEBAR_BANNER: 'SIDEBAR_BANNER',
};

export default AdZones;
